import {
  SALESWARRANTY_LOADING,
  GET_SALESWARRANTY,
  GET_SALESWARRANTY_SUCCESS,
  GET_SALESWARRANTY_FAIL,
  ADD_SALESWARRANTY_SUCCESS,
  ADD_SALESWARRANTY_FAIL,
  DELETE_SALESWARRANTY_SUCCESS,
  DELETE_SALESWARRANTY_FAIL,
  UPDATE_SALESWARRANTY_SUCCESS,
  UPDATE_SALESWARRANTY_FAIL,
  SALESWARRANTY_RESET
} from "./actionType";

const INIT_STATE = {
  salesWarranties: [],
  error: {},
};

const SalesWarranty = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESWARRANTY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESWARRANTY:
          return {
            ...state,
            salesWarranties: action.payload.data,
            isSalesWarrantyCreated: false,
            isSalesWarrantySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESWARRANTY_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESWARRANTY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesWarrantyCreated: false,
            isSalesWarrantySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESWARRANTY: {
      return {
        ...state,
        isSalesWarrantyCreated: false,
        loading: true,
      };
    }

    case SALESWARRANTY_LOADING: {
      return {
        ...state,
        isSalesWarrantyCreated: false,
        loading: true,
      };
    }

    case ADD_SALESWARRANTY_SUCCESS:
      return {
        ...state,
        isSalesWarrantyCreated: true,
        loading: false,
        salesWarranties: [action.payload.data, ...state.salesWarranties],
      };

    case ADD_SALESWARRANTY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESWARRANTY_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesWarrantyCreated: true,
        salesWarranties: state.salesWarranties.filter(
          salesWarranty => salesWarranty.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESWARRANTY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESWARRANTY_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesWarrantyCreated: true,
        salesWarranties: state.salesWarranties.map(salesWarranty =>
          salesWarranty.id.toString() === action.payload.data.id.toString() ? { ...salesWarranty, ...action.payload.data } : salesWarranty
        ),
      };

    case UPDATE_SALESWARRANTY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESWARRANTY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesWarranty;